export default __webpack_public_path__ + "static/moon_bunnies_e-73f7af57c8be6349a452564f5695f95a.jpg";